export enum DashboardSetupStep {
  FORM = "FORM",
  ENTRY = "ENTRY",
  WHATSAPP = "WHATSAPP",
  TEAM = "TEAM",
  DEAL = "DEAL",
  TASK = "TASK",
}
